export function styleResetFunc() {
  console.log('読み込めてます');
}

